module.exports = __webpack_public_path__ + "static/media/USDA_Home_Loans.3c35b15a.png";